import { render, staticRenderFns } from "./Yext.vue?vue&type=template&id=87709d44&scoped=true&"
import script from "./Yext.vue?vue&type=script&lang=js&"
export * from "./Yext.vue?vue&type=script&lang=js&"
import style0 from "./Yext.vue?vue&type=style&index=0&id=87709d44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87709d44",
  null
  
)

export default component.exports